import React from "react";
import { APICall } from "../../../api_helper";
import { DropdownFillers } from "../../../types";
import { useQueryWrapper } from "../../../helper";
import { FormDropdown } from "semantic-ui-react";

export const NewMultipleSelectionQueryDropdownFieldComponent = (props: {
  props: NewMultipleSelectionQueryDropdownFieldComponentProps;
  data: any;
  setData: any;
}) => {
  const [options, setOptions] = React.useState<DropdownFillers[]>([]);

  useQueryWrapper(
    props.props.apiCall.documentNode,
    props.props.apiVariables,
    (data) => {
      const newOptions: DropdownFillers[] = [];
      for (const response of data[props.props.apiCall.key]) {
        newOptions.push({
          text: response.name,
          value: response.id,
          key: response.id,
        });
      }
      setOptions(newOptions);
    },
  );

  // This component is a placeholder for the actual implementation of the MultipleSelectDropdownComponent.
  // The implementation would be similar to DropdownComponent but would handle multiple selections.
  return (
    <FormDropdown
      fluid
      multiple
      selection
      search
      label={props.props.label}
      placeholder={"Select " + props.props.itemName}
      required={props.props.required}
      options={options}
      value={props.data[props.props.key]}
      onChange={(event, data) => {
        const newValues = { ...props.data };
        newValues[props.props.key] = data.value;
        props.setData(newValues);
      }}
    />
  ); // Replace with actual implementation
};

export type NewMultipleSelectionQueryDropdownFieldComponentProps = {
  type: "multiple_selection_query_dropdown";
  key: string;
  label: string;
  required: boolean;
  apiCall: APICall;
  apiVariables: any;
  itemName: string;
};
